import { GroupDef, InjectKey } from "./Types"

export const GROUPS: GroupDef[] = [
	{ key: "understand", label: "Understanding your trip", icon: "understand" },
	{ key: "destinations", label: "Choosing destinations", icon: "pin" },
	{ key: "route", label: "Planning your route", icon: "route" },
	{ key: "hotels", label: "Finding your stays", icon: "bed" },
	{ key: "activities", label: "Things to do", icon: "ticket" },
	{ key: "transfers", label: "Flights & transfers", icon: "plane" },
]

export const INJECT_LABEL: Record<InjectKey, string> = {
	destination: "New destination",
	hotels: "Hotels",
	activities: "Activities",
	transfers: "Transfers",
}

export const INJECT_ICON: Record<
	InjectKey,
	keyof typeof import("./Icons").ICONS
> = {
	destination: "pin",
	hotels: "bed",
	activities: "ticket",
	transfers: "car",
}

export const LOADING_MESSAGES = [
	// Core Platform
	"Manage your entire travel business in one place",
	"Get a role-based dashboard built for your team",
	"Find any trip instantly with global search",
	"Secure your account with passkeys & 2FA",

	// Leads & Queries
	"Capture leads from every source, automatically",
	"Never miss a follow-up on a query",
	"Assign tasks and keep your team in sync",

	// Trip Planning
	"Build day-wise itineraries in seconds",
	"Manage guests, tourists and their documents",
	"Auto-calculate tour costing as you plan",

	// Quotation
	"Create professional quotes in minutes",
	"Offer up to 6 package options in a single quote",
	"Quote in multiple currencies with ease",
	"Search and add flights instantly",
	"Share quotes over WhatsApp & Email",
	"Download quotes as branded PDF or Word",

	// Bookings & Operations
	"Automate hotel booking requests",
	"Track every reservation from enquiry to confirmation",
	"Schedule cabs and manage tour operations",
	"Assign suppliers with a single click",
	"Generate trip vouchers guests can carry",
	"Keep all your travel documents organized",

	// Accounting & Payments
	"Track every payment coming in and going out",
	"Collect payments online with instant confirmation",
	"Send automated payment reminders",
	"Generate proforma invoices in seconds",

	// Organization & Data
	"Manage your team, roles and permissions",
	"Maintain hotels, transport & supplier data",
	"Bulk upload data with CSV",

	// Reports & Automation
	"Track sales performance with live reports",
	"Get operational reports for every trip",
	"Let AI parse enquiry emails for you",
]
export const MESSAGE_INTERVAL_MS = 3000

export const SPAWN_INTERVAL_MS = 1600
export const MAX_CONCURRENT_ITEMS = 3
export const TRAVEL_MS = 2600

export const INJECT_ACCENT: Record<InjectKey, string> = {
	destination: "#FF8FB4",
	hotels: "#8FD4FF",
	activities: "#FFD98F",
	transfers: "#8FFFC7",
}
